import { render, staticRenderFns } from "./stock-edit.vue?vue&type=template&id=10c92869"
import script from "./stock-edit.vue?vue&type=script&lang=ts"
export * from "./stock-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports